import LeakAddIcon from '@mui/icons-material/LeakAdd';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const referralRequests = {
    id: 'referralRequests',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'referralRequests',
            title: 'Referral Requests',
            type: 'item',
            url: '/referralRequests',
            icon: LeakAddIcon,
            breadcrumbs: false,
            
        }
    ]
};

export default referralRequests;
